module.exports = __webpack_public_path__ + "static/TakeshiAndHiroshi3-7a3959d0c86500dde5f9cc8f29369ee8.webp";